import { createFileRoute } from '@tanstack/react-router';
import { eventBannerSlot } from '@/app/commercial/slots';
import { ErrorState, Page, Skeleton } from '@/core/ui';
import { EventEditor, eventQuery, useEvent } from '@/modules/events/public';
import { RequirePermission, usePermissions } from '@/modules/identity/public';

export const Route = createFileRoute('/_admin/eventos/$eventId')({
  loader: ({ context, params }) => context.queryClient.prefetchQuery(eventQuery(params.eventId)),
  component: function EventRoute() {
    const { eventId } = Route.useParams();
    const navigate = Route.useNavigate();
    const { can } = usePermissions();
    const event = useEvent(eventId);
    return (
      <RequirePermission anyOf={['eventos.ver']}>
        {event.isPending ? (
          <Page>
            <Skeleton className="h-96 rounded-2xl" />
          </Page>
        ) : event.isError ? (
          <Page>
            <ErrorState error={event.error} onRetry={() => void event.refetch()} />
          </Page>
        ) : (
          <EventEditor
            // Remonta ao trocar de evento: o formulário nasce dos dados dele.
            key={event.data.id}
            event={event.data}
            canEdit={can('eventos.editar')}
            imageSlot={eventBannerSlot}
            onBack={() => navigate({ to: '/eventos' })}
            onSaved={() => undefined}
            onDeleted={() => navigate({ to: '/eventos' })}
          />
        )}
      </RequirePermission>
    );
  },
});
